import { ModuleConfig } from '@core/interfaces';

let param = localStorage.getItem('myToken');
const config: ModuleConfig = {
  name: 'Find-Password',
  baseUrl: '',
  routes: [
    {
      path: '/admin/find-password',
      page: 'ForgotPass',
      title: 'Forgot pass',
      exact: true
    },
    {
      path: `/admin/reset-password/:token`,
      page: 'ChangePass',
      title: 'Reset password',
      exact: true
    }
  ],
  requireAuthenticated: false
};

export default config;
